// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"da3b0563","366":"67751a6d","367":"ecfbad8d","733":"8ebe29f7"}[chunkId] + ".chunk.js";
};